export const SET_ALL_REGIONS_LIST = 'set all regions list';
export const SET_LOGIN_MODEL = 'set login model';
export const SET_HIDDEN_FIELDS = 'set hidden fields';
export const OPEN_SEARCH = 'open search';
export const SET_ERROR = 'error popup show';
export const SET_REGION = 'set current region';
export const SET_CURRENT_CTN = 'set current ctn';
export const SET_USER = 'set user';
export const SET_AUTH_DATA = 'set auth data';
